import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CompanyAddress, Address } from 'src/shared/api';

@Component({
	selector: 'rpshared-billing-address-select',
	templateUrl: './billing-address-select.component.html',
})
export class BillingAddressSelectComponent implements OnChanges {
	@Input() addresses: CompanyAddress[] = [];
	@Input() selectedAddressId: number | null = null;
	@Output() addressSelected = new EventEmitter<CompanyAddress>();

	searchControl: FormControl = new FormControl('');
	filteredAddresses$: Observable<CompanyAddress[]>;

	ngOnChanges(changes: SimpleChanges) {
		if (changes.addresses) {
			this.filteredAddresses$ = this.searchControl.valueChanges.pipe(
				startWith(''),
				map((value) =>
					typeof value === 'string' ? this.filter(value) : this.addresses
				)
			);
		}
		if (changes.addresses || changes.selectedAddressId) {
			const selected = this.addresses.find(
				(ca) => ca.address?.id === this.selectedAddressId
			);
			if (selected) {
				this.searchControl.setValue(selected, { emitEvent: false });
			}
		}
	}

	private filter(query: string): CompanyAddress[] {
		const lowerQuery = query.toLowerCase();
		return this.addresses.filter((ca) =>
			this.formatAddress(ca.address).toLowerCase().includes(lowerQuery)
		);
	}

	displayAddress = (ca: CompanyAddress): string => {
		return ca ? this.formatAddress(ca.address) : '';
	};

	formatAddress(address: Address): string {
		if (!address) {
			return '';
		}
		return `${address.address1 || ''}, ${address.city || ''}, ${
			address.state || ''
		} ${address.zipCode || ''}`;
	}
}
